var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 225,
    height: 81.028,
    viewBox: "0 0 225 81.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 81.028,
    fill: "#e3b964"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.691,59.51a19.027,19.027,0,0,0,7.66,2.1c2.023,0,4.257-1.016,4.257-2.524a1.83,1.83,0,0,0-1.114-1.547,12.13,12.13,0,0,0-2.654-.475,15.567,15.567,0,0,1-4.456-.953,6.816,6.816,0,0,1-4.209-6.4c0-4.839,4.086-7.5,9.2-7.5a15.13,15.13,0,0,1,7.655,1.826v5.205a17.508,17.508,0,0,0-7.13-1.418c-1.824,0-3.46,1.095-3.46,2.325,0,1.01.748,1.848,3.074,1.967.542.028,1.91.153,3.045.306,3.813.514,6.033,2.8,6.033,6.523,0,5.277-4.614,8.1-9.2,8.1a24.91,24.91,0,0,1-8.707-1.667Z",
    transform: "translate(-1.539 -0.81)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.137,59.51a19.027,19.027,0,0,0,7.659,2.1c2.024,0,4.258-1.016,4.258-2.524a1.83,1.83,0,0,0-1.114-1.547,12.139,12.139,0,0,0-2.654-.475,15.567,15.567,0,0,1-4.456-.953,6.816,6.816,0,0,1-4.209-6.4c0-4.839,4.086-7.5,9.2-7.5a15.137,15.137,0,0,1,7.656,1.826v5.205a17.515,17.515,0,0,0-7.131-1.418c-1.824,0-3.461,1.095-3.461,2.325,0,1.01.749,1.848,3.075,1.967.542.028,1.91.153,3.045.306,3.813.514,6.033,2.8,6.033,6.523,0,5.277-4.614,8.1-9.2,8.1a24.91,24.91,0,0,1-8.707-1.667Z",
    transform: "translate(-4.043 -0.81)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.11,34.627l-7.717-23.185h5.842l4.438,14.736,5.5-14.736h6.169l-2.583,6.925c-5.67,16.442-11.649,16.26-11.649,16.26",
    transform: "translate(-2.963 -0.22)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.084,
    height: 23.202,
    transform: "translate(186.716 11.222)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.069,11.442v5.215H218.451v3.627H224.5v5.1h-6.048v4.006h10.618v5.252H212.479v-23.2Z",
    transform: "translate(-4.078 -0.22)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.505,42.213v23.2h-6.084V59.9h-8.956v5.518h-6.084v-23.2h6.084V54.682h8.956V42.213Z",
    transform: "translate(-2.138 -0.81)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,42.213h20.406v5.215h-7.18v18.9h-6.084v-18.9H180Z",
    transform: "translate(-3.455 -0.81)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.321,22.811a8.009,8.009,0,0,0-.435-2.7,5.765,5.765,0,0,0-1.315-2.12,6.092,6.092,0,0,0-2.15-1.4,7.934,7.934,0,0,0-2.934-.5,6.675,6.675,0,0,0-5,1.855,6.656,6.656,0,0,0-1.816,4.866,6.351,6.351,0,0,0,6.815,6.739,7.481,7.481,0,0,0,3.711-.861,5.737,5.737,0,0,0,2.326-2.385,7.432,7.432,0,0,0,.8-3.493m6.416,0a12.284,12.284,0,0,1-1.507,6.01,10.892,10.892,0,0,1-4.486,4.361,15.031,15.031,0,0,1-7.256,1.616,14.747,14.747,0,0,1-7.324-1.684,10.957,10.957,0,0,1-4.454-4.428,12.635,12.635,0,0,1-.008-11.76,10.857,10.857,0,0,1,4.453-4.411,14.871,14.871,0,0,1,7.332-1.675,16.207,16.207,0,0,1,5.766.96,11.539,11.539,0,0,1,4.166,2.6,10.929,10.929,0,0,1,2.475,3.821,12.626,12.626,0,0,1,.842,4.587",
    transform: "translate(-2.251 -0.208)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.826,54.264a7.984,7.984,0,0,0-.436-2.7,5.739,5.739,0,0,0-1.315-2.12,6.079,6.079,0,0,0-2.149-1.4,7.934,7.934,0,0,0-2.934-.5,6.738,6.738,0,1,0,0,13.46,7.474,7.474,0,0,0,3.71-.861,5.733,5.733,0,0,0,2.327-2.385,7.435,7.435,0,0,0,.8-3.493m6.416,0a12.284,12.284,0,0,1-1.508,6.01,10.892,10.892,0,0,1-4.486,4.361,15.034,15.034,0,0,1-7.256,1.616,14.746,14.746,0,0,1-7.324-1.684,10.957,10.957,0,0,1-4.454-4.428,12.635,12.635,0,0,1-.008-11.76,10.851,10.851,0,0,1,4.453-4.411,14.871,14.871,0,0,1,7.333-1.675,16.207,16.207,0,0,1,5.766.96,11.539,11.539,0,0,1,4.166,2.6,10.929,10.929,0,0,1,2.475,3.821,12.625,12.625,0,0,1,.843,4.587",
    transform: "translate(-2.74 -0.812)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,24.517v9.637H80.97v-23.2a45.8,45.8,0,0,1,8.39,6.3c2.044,2.168,3.589,4.06,3.589,4.06s1.511-1.845,3.519-3.978c1.987-2.11,7.9-6.384,8.46-6.384v23.2H98.957V24.517l-6.008,8.314Z",
    transform: "translate(-1.554 -0.21)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0S19.2,2.1,29.823,15.319c0,0,9.779-10.921,29.012-11.841l-12.4,53.2-7.638,2.5s4.28-32.791,4.932-37.787c-3.656,2.989-8.517,6.094-9.142,17.731C33.66,56.436,33.416,60.99,33.416,60.99L26.36,63.414s-.8-14.859-1.324-24.681C24.582,30.27,22.819,24.979,15.7,19.74l5.917,45.34-5.952,2.132Z",
    transform: "translate(0 0)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.78,69.8l.134-.032,4.228-9.94q-4.4,1.362-8.726,2.745l-2.789,9.017c2.594-.663,4.991-1.261,7.153-1.789",
    transform: "translate(-0.933 -1.148)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.588,72.93l1.969-8.451c-2.274.741-4.541,1.483-6.782,2.23l-1.014,7.774q3.034-.821,5.827-1.554",
    transform: "translate(-0.725 -1.238)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.145,75.769l.39-7.279q-3.156,1.073-6.262,2.152l.359,6.673q2.829-.8,5.513-1.547",
    transform: "translate(-0.523 -1.315)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.453,78.532l-.819-6.266c-1.771.626-3.522,1.254-5.267,1.884l1.344,5.77q2.414-.714,4.742-1.388",
    transform: "translate(-0.333 -1.387)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.832,81.092l-1.686-5.405c-1.461.535-2.925,1.069-4.913,1.814l2.033,4.98q2.316-.712,4.566-1.389",
    transform: "translate(-0.158 -1.453)",
    fill: "#e3b964"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.109f416fe5b198704a6c60c20f1a6bba.svg";
export { ForwardRef as ReactComponent };